import type { ResponderDictationControl } from './shared-responder-v2-capability-coordinator.hooks';

export const DICTATION_PHASES = {
  Idle: 'idle',
  RequestingPermission: 'requestingPermission',
  Listening: 'listening',
  Unsupported: 'unsupported',
  PermissionDenied: 'permissionDenied',
  NoInputDevice: 'noInputDevice',
  RecognitionFailed: 'recognitionFailed',
} as const;

export type DictationPhase =
  (typeof DICTATION_PHASES)[keyof typeof DICTATION_PHASES];

export const DICTATION_INTERIM_COMMIT_DELAY_MS = 400;

export const REMOTE_DICTATION_CONTROL: ResponderDictationControl = {
  isDictating: true,
  start: () => undefined,
  stop: () => undefined,
};
